import TroubleshootingPanel from './troubleshooting-panel'
import { Hr, TroubleshootingContent } from './troubleshooting-panels.styles'

export const TroubleshootingPanelConnectionErrorContent = () => {
  return (
    <TroubleshootingContent>
      <p>
        <strong>How to Resolve</strong>
      </p>
      <ul>
        <li>Check that the cables are properly connected.</li>
        <li>Ensure the outlet has electricity and is not controlled by a light switch.</li>
        <li>Check the placement area for signal interference (walls/metal, etc).</li>
        <li>Ensure the ethernet port the device is connected to has internet connectivity.</li>
      </ul>
      <Hr />
      <p>
        For further assistance, please contact Sensor Support at (844) 468-1866 Monday – Friday, 8 a.m. – 8 p.m. Eastern
        Time
      </p>
    </TroubleshootingContent>
  )
}

export const TroubleshootingPanelConnectionError = () => {
  return (
    <TroubleshootingPanel title="Connection Error" modalIndexValue="connection_error">
      <TroubleshootingPanelConnectionErrorContent />
    </TroubleshootingPanel>
  )
}
